import { Input } from "reactstrap";
import { searchProduct } from "../services/product-service";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const SearchProductHome=()=>{

    let navigate = useNavigate()

    const [page,setPage] = useState({
        "totalPages":'',
        "pageSize":'',
        "pageNumber":'',
        "totalElements":'',
        "lastPage":false,
        "products":[]

    })

    const searchForProduct=(key)=>{

        if(key==""){
            document.querySelector("#searchResult").style.display="none"
            return;
        }
        document.querySelector("#searchResult").style.display="block"
        searchProduct(key).then(response=>{
            //console.log(response)
            setPage(response)

        }).catch(error=>{
            console.log(error)
        })
    }

    return (
        <>


                    <Input type="text" className="form-control" onChange={(event)=>searchForProduct(event.target.value)} id="searchBox" placeholder="HomeoRx | Search for products"  />
                            <div class="input-group-append"  onClick={()=>navigate(`/home/${document.getElementById("searchBox").value}`)} >
                                 <span class="input-group-text bg-transparent text-primary">
                                    <i class="fa fa-search"></i>
                                </span>
                             </div>
                

                <div className="searchResult" id="searchResult" style={{display:"none"}}>
                    
                    {
                        page.products.map((product,index)=>(
                            <>
                            <p onClick={()=>navigate(`/product/${product.id}`)} className="myHover">{product.name} </p> 
                            </>
                        ))
                    }
                </div>
        
        </>
    )

}

export default SearchProductHome